import Vue from 'vue'
import state from 'lib/appState'
import ProductCardMixin from 'modules/product-card/product-card-mixin'

Vue.component('simple-product-card', {
  mixins: [ProductCardMixin],
  props: [
    'product',
    'featured'
  ],
  data () {
    let product
    if (!!this.decode && this.product) {
      product = JSON.parse(decode(this.product))
    } else {
      product = (this.product || {
        title: '',
        price: '',
        featuredImage: '',
        variants: [],
        optionNames: []
      })
    }
    return {
      state,
      quickBuyActive: false,
      loading: false,
      ...product,
      activeOption: ''
    }
  }
})
